<template>
  <div>
    <van-popup v-model="showPop" position="right" style="height: 100%; width: 80%" @click-overlay="closePopup">
      <div class="btn-wrap">
        <div class="pop-title">
          <p>搜索筛选区</p>
          <van-icon name="cross" @click="cancel" />
        </div>
      </div>
      <div class="input-wrap">
        <!-- 客户id 银行名称 到账日期  提单已审核专用搜索框 -->
        <van-cell-group v-if="!isPerformance">
          <van-field v-if="userId == '2' || userId == '19' || userId == '20' || userId == '162' || userId == '16' || userId == '80'" readonly clickable v-model="deptName" @click="showPicker('dept')" label="部门" placeholder="选择部门" />
          <van-field v-if="type" readonly clickable v-model="businessTypeName" @click="showPicker2('businessType')" label="业务类型" placeholder="请选择业务类型" />
          <van-field readonly clickable v-model="queryParams.industryName" label="所属行业" @click="showPicker('industry')" placeholder="请选择所属行业" />
          <van-field readonly clickable v-model="queryParams.custLevelName" @click="showPicker('custLevel')" label="客户等级" placeholder="请选择客户等级" />
          <van-field readonly clickable v-model="address" label="地区" @click="showArea" placeholder="请选择所在区域" />
          <van-field v-model="time" readonly clickable name="calendar" label="时间" placeholder="点击选择时间" @click="showCalendar()" />

        </van-cell-group>
        <van-cell-group v-if="isPerformance">
          <van-field v-model="time" readonly clickable name="calendar" label="时间" placeholder="点击选择时间" @click="showCalendar()" />
        </van-cell-group>
      </div>
      <div class="footer-btn-wrap">
        <van-button size="mini" type="primary" class="resetBtn" @click="resetQuery">重置</van-button>
        <van-button size="mini" type="info" class="submitbtn" @click="submitForm">搜索</van-button>
        <van-button size="mini" type="info" class="submitbtn" @click="cancel">取消</van-button>
      </div>
    </van-popup>
    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
    </van-popup>
    <van-popup v-model="tree.typeTree" position="bottom">
      <van-cascader :title="tree.title" :options="tree.treeList" @change="treeChange" :field-names="tree.fieldNames" @close="tree.typeTree = false" @finish="onFinishTree" />
    </van-popup>
    <van-dialog v-model="areashow" width='98%' title="" :showConfirmButton='false' @close='areashow=false'>
      <van-area title="选择地区" @confirm = 'areaConfirm'  @cancel= 'areaCancel' :area-list="areaList" :columns-num="1" />
    </van-dialog>
    <van-calendar v-model="datePicker.showDate" :min-date="datePicker.minDate" :type="datePicker.type" @confirm="dateConfirm" allow-same-day />
  </div>
</template>
<script>
// import { selectAllCustLevel } from "@/api/scrm/custlevel";
import { Cascader } from 'vant'
import statistics from '@/api/tongji/statistics'
import { businessTypeList } from '@/api/admi/dept'
import { areaList } from '@vant/area-data'
// import { getDistrict } from '@/api/scrm/mycust'
import { getdistrict } from '@/api/system/district.js'
import { getTwoLevelIndustryList } from '@/api/system/qqAdIndustry'
import { handleTree } from '@/utils/util'
import { getDicts } from '@/api/system/dict/data'
export default {
  name: 'SearchPop',
  props: ['show', 'type', 'isPerformance'],
  components: {
    vanCascader: Cascader
    // [Button.name]: Button,
    // [Popup.name]: Popup,
    // [Field.name]: Field,
    // [Icon.name]: Icon,
    // [Cell.name]: Cell,
    // [CellGroup.name]: CellGroup,
    // [Collapse.name]: Collapse,
    // [CollapseItem.name]: CollapseItem,
    // [Divider.name]: Divider
  },
  data() {
    return {
      userId: '',
      activeNames: ['1'],
      showPop: false,
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      tree: {
        type: '',
        title: '',
        typeTree: false,
        treeList: [],
        fieldNames: {

        }
      },
      datePicker: {
        showDate: false,
        minDate: new Date(2010, 0, 1),
        type: 'single',
        formKey: ''
      },
      time: '',
      deptName: '',

      // signTime: '',
      // businessTypeName: '',
      businessTypeTreeList: '',
      deptList: [], // 公司列表
      areashow: false,
      areaList: areaList,
      address: '',
      options: {
        industryOptions: [],
        custLevelOptions: []
      },
      value: null,
      contractTypeIndex: null,
      contractStatusIndex: null,
      minDate: new Date(2010, 0, 1),
      minDateStart: new Date(2010, 0, 1),
      businessTypeName: null,
      contractStatusName: '',
      custLevelIndex: null,
      custSourceIndex: null,
      custTypeIndex: null,
      queryParams: {},
      // 客户等级
      custLevelOptions: [],
      // 客户来源字典
      custSourceOptions: this.$store.state.dictOptions.custSource || [],
      // 客户类型
      custTypeOptions: this.$store.state.dictOptions.crmCustType || []
    }
  },
  watch: {
    show: function (newVal, oldVal) { // 不能用箭头函数
      this.showPop = newVal
    }
  },
  mounted() {
    // this.getCustLevelList()
    this.userId = this.$store.state.user.user.userId
    getDicts('crm_cust_level').then(res => {
      this.options.custLevelOptions = res.data
    })
  },
  methods: {
    handleClick(type, prop, index) {
      switch (type) {
        case 'custLevel':
          this.queryParams.custLevelId = prop
          this.custLevelIndex = index
          break
        case 'custSource':
          this.queryParams.custSource = prop
          this.custSourceIndex = index
          break
        case 'custType':
          this.queryParams.custType = prop
          this.custTypeIndex = index
          break
        default:
          console.log('handleClick', type, prop)
      }
    },
    // 获取用户等级
    // getCustLevelList() {
    //   selectAllCustLevel(null).then(response => {
    //     this.custLevelOptions = response.data;
    //   });
    // },
    handleFilter() {
      this.showPop = true
    },
    resetQuery() {
      this.time = ''
      this.deptName = ''
      this.address = ''
      this.businessTypeName = ''
      this.queryParams.deptId = null
      this.queryParams.startTime = null
      this.queryParams.endTime = null
      this.queryParams.province = null
      this.queryParams.businessTypeId = null
      this.queryParams.custLevel = null
      this.queryParams.custLevelName = null
      this.queryParams.industryName = null
      this.queryParams.industryCode = null
      this.queryParams.dayType = '1'
    },
    async showPicker(type) {
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      // const optionItem = type + 'Options'
      // if (type === 'contractStatus') {
      //   if (this.options.contractStatusOptions.length == 0) {
      //     // 合同状态
      //     await getDicts('contract_status').then(res => {
      //       this.options.contractStatusOptions = res.data
      //     })
      //   }
      //   this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
      // }
      if (type === 'dept') {
      // 获取公司信息
        if (this.deptList.length == 0) {
          await statistics.getDeptList({ isBuss: '1' }).then((response) => {
            this.deptList = response.data
          })
        }
        this.picker.columns = this.deptList.map((ele) => ele.deptName)
      } else if (type === 'industry') {
        if (this.options.industryOptions.length == 0) {
          await getTwoLevelIndustryList().then((res) => {
            this.options.industryOptions = handleTree(res.data, 'systemIndustryId')
            this.options.industryOptions.map(item => {
              item.dictLabel = item.industryName
              item.dictValue = item.systemIndustryId
            })
          })
        }
        // this.picker.formKey = type
        const optionItem = type + 'Options'
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.visible = true
      } else {
        const optionItem = type + 'Options'
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.visible = true
      }
      this.picker.loading = false
      this.picker.visible = true
    },
    pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      if (this.picker.formKey === 'dept') {
        this.deptName = this.deptList[key].deptName
        this.queryParams.deptId = this.deptList[key].deptId.toString()
      } else if (this.picker.formKey == 'industry') {
        this.queryParams.industryName = value
        this.queryParams.industryCode = this.options.industryOptions[key].dictValue
      } else {
        const name = this.picker.formKey + 'Name'
        this.queryParams[this.picker.formKey] = this.options[optionItem][key].dictValue
        this.queryParams[name] = this.options[optionItem][key].dictLabel
      }
      this.picker.visible = false
    },
    // 去除树形数据的空children
    removeEmptyChildren(node) {
      node.forEach(item => {
        if ('children' in item && item.children.length === 0) {
          delete item.children
        } else if ('children' in item && item.children.length) {
          this.removeEmptyChildren(item.children)
        }
      })
      return node
    },
    /** 转换地区数据结构 */
    areaNormalizer(node) {
      const arr = []
      if (node.children && node.children.length) {
        for (const i in node.children) {
          const item = {
            id: node.children[i].areaId,
            text: node.children[i].areaName
          }
          arr.push(item)
        }
      }

      return {
        id: node.areaId,
        text: node.areaName,
        children: arr
      }
    },
    /** 转换业务类型数据结构 */
    getData (arr) {
      // 利用两层filter实现
      const data = arr.filter(item => {
        item.children = arr.filter(e => {
          return item.businessTypeId === e.parentId
        })
        return !item.parentId
      })
      return this.removeEmptyChildren(data)
    },
    async showPicker2(val) {
      // if (val === 'dept') {
      //   if (this.deptTreeList.length == 0) {
      //     // 获取部门信息
      //     await CascaderTreeSelect().then((response) => {
      //       this.deptTreeList = response.data
      //     })
      //   }
      //   this.tree = {
      //     type: val,
      //     title: '请选择部门',
      //     typeTree: true,
      //     treeList: this.deptTreeList,
      //     fieldNames: {}
      //   }
      // } else
      if (val === 'businessType') {
        if (this.businessTypeTreeList.length == 0) {
          // 获取获取业务类型
          await businessTypeList({ pageNum: 1, pageSize: 500 }).then((response) => {
            if (response.code === 200) {
              this.businessTypeTreeList = this.getData(response.rows)
            }
          })
        }
        this.tree = {
          type: val,
          title: '请选择业务类型',
          typeTree: true,
          treeList: this.businessTypeTreeList,
          fieldNames: {
            text: 'businessTypeName',
            value: 'businessTypeId'
          }
        }
      }
    },
    showCalendar(type) {
      this.datePicker.formKey = type
      // if (type === 'signTime' || type === 'executionTime') {
      this.datePicker.type = 'range'
      // } else {
      //   this.datePicker.type = 'single'
      // }
      this.datePicker.showDate = true
    },
    dateConfirm(date) {
      this.queryParams.dayType = null
      this.activeId = null
      // this.minDate = date
      // if (this.datePicker.formKey === 'signTime') {
      //   const [start, end] = date
      //   this.queryParams.params.beginTime = this.formatDate(start)
      //   this.queryParams.params.endTime = this.formatDate(end)
      //   this.signTime = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
      // } else if (this.datePicker.formKey === 'executionTime') {
      const [start, end] = date
      this.queryParams.startTime = this.formatDate(start)
      this.queryParams.endTime = this.formatDate(end)
      this.time = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
      // } else {
      //   this.queryParams[this.datePicker.formKey] = this.formatDate(date)
      // }
      this.datePicker.showDate = false
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    treeChange(obj) {
      // if (this.tree.type === 'dept') {
      //   this.queryParams.deptId = obj.value
      //   this.queryParams.deptName = obj.selectedOptions.map((option) => option.text).join('/')
      // }
      console.log(this.queryParams)
    },
    onFinishTree(obj) {
      if (this.tree.type === 'businessType') {
        this.queryParams.businessTypeId = obj.value
        this.businessTypeName = obj.selectedOptions.map((option) => option.businessTypeName).join('/')
      }
      if (this.tree.type === 'dept') {
        this.queryParams.deptId = obj.value
        this.deptName = obj.selectedOptions.map((option) => option.text).join('/')
      }
      this.tree.typeTree = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    showArea() {
      this.areashow = true
    },
    // 省市区
    getdistrict(parent, type) {
      getdistrict({ parent: parent }).then((res) => {
        if (type == 1) {
          const province = res.rows
          for (let i = 0; i < province.length; i++) {
            const item = province[i]

            this.areaList.province_list[item.id] = item.fullname
          }
        } else if (type == 2) {
          const city = res.rows
          for (let i = 0; i < city.length; i++) {
            const item = city[i]
            this.areaList.city_list[item.id] = item.fullname
          }
        } else if (type == 3) {
          const county = res.rows
          for (let i = 0; i < county.length; i++) {
            const item = county[i]
            this.areaList.county_list[item.id] = item.fullname
          }
        }
      })
    },
    areaConfirm(values) {
      this.queryParams.province = values[0].code
      // this.queryParams.city = values[1].code
      // this.queryParams.area = values[2].code
      this.address = values[0].name
      //  + values[1].name + values[2].name
      this.areashow = false
      // getDistrict(values[2].code).then(res => {
      //   const data = res.data
      //   this.queryParams.latLong = data.lat + ',' + data.lng
      // })
    },
    areaCancel() {
      this.areashow = false
    },
    // resetQuery() {
    //   this.queryParams = {
    //     custLevelId: null,
    //     custName: null,
    //     custSource: null,
    //     custType: null,
    //     boName: null
    //   }
    //   this.custLevelIndex = null
    //   this.custSourceIndex = null
    //   this.custTypeIndex = null
    // },
    submitForm() {
      console.log(this.queryParams)
      this.$emit('handlequery', this.queryParams)
    },
    cancel() {
      this.showPop = false
      this.$emit('update:show', false)
    },
    closePopup() {
      this.showPop = false
      this.$emit('update:show', false)
    }
  }
}
</script>
<style lang="less">
.btn-wrap {
  width: 100%;
  box-sizing: border-box;
  .close-icon {
    width: 20px;
    height: 20px;
  }
  .pop-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 36px;
    font-weight: bold;
    padding: 0;
    padding: 0 30px;
  }
  .type-list {
    margin-bottom: 40px;
    .title {
      font-size: 28px;
      font-weight: bold;
    }
    .list-wrapper {
      line-height: 0.5;
    }
  }
  .input-wrap {
    margin-top: 20px;
  }
  .select_list {
    .van-button {
      margin-top: 10px !important;
      margin-bottom: 10px !important;
    }
  }
}
.footer-btn-wrap {
  position: fixed;
  bottom: 100px;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 30px;

  display: flex;
  justify-content: space-around;

  .van-button {
    width: 45%;
    height: 60px;
    font-size: 30px;

    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  }
}
</style>
